<mat-toolbar>
  <mat-toolbar-row class="header">
    <div id="brand">
      <a *ngIf="isnps"
        ><img src="../../assets/img/Logo_MTX_header.svg" alt="MeilleurtauxSante"
      /></a>
      <a href="/demande-devis" *ngIf="!isnps"
        ><img src="../../assets/img/Logo_MTX_header.svg" alt="MeilleurtauxSante"
      /></a>
    </div>
    <div class="txtMilieu" *ngIf="!isnps">
      <div class="phone-div">
        <img src="assets/img/phone2.svg" alt="MeilleurtauxSante" />
        <p class="phone-number">{{ number_phone }}</p>
      </div>
      <p class="text-phone">
        Appel & Service gratuit · Lundi au vendredi de 9h à 19h
      </p>
    </div>

    <nav *ngIf="!isnps" class="nav-trustpilot">
      <ul>
        <!--
            "5406e65db0d04a09e042d5fc" horizontale
         -->

        <li>
          <!-- TrustBox widget - Mini -->
          <div
            class="trustpilot-widget"
            data-locale="fr-FR"
            data-template-id="53aa8807dec7e10d38f59f32"
            data-businessunit-id="4bed2d5e00006400050b76ec"
            data-style-height="90px"
            data-style-width="100%"
            data-theme="light"
            data-font-family="Poppins"
          >
            <a
              href="https://fr.trustpilot.com/review/www.meilleurtaux.com"
              target="_blank"
              rel="noopener"
              >Trustpilot</a
            >
          </div>
          <!-- End TrustBox widget -->
        </li>
      </ul>
    </nav>
  </mat-toolbar-row>
</mat-toolbar>
